<template>
    <base-layout
        v-if="accountStatus"
        :header-type="headerType.ALL"
        :footer-type="footerType.PRIMARY"
        :latest-image-id="latestImageId"
        :unsaved-puri-count="unsavedPuriCount"
        :is-header-sticky="false"
    >
        <!-- プラポリ同意取得モーダル -->
        <wrapper-modal-privacy-policy-agreement/>
        <loading-heart v-if="isLoadingData" data-jest="data-loading"/>
        <div v-else class="is-full-width is-full-height">
            <error-not-found-content v-if="isErrorNotFound" data-jest="error-not-found"/>
            <div v-else>
                <loading-heart v-if="isLoadingTopImage"/>
                <div v-show="!isLoadingTopImage" class="c-machine-introduction">
                    <!--公開日より前の表示-->
                    <div v-if="!isPagePublished" class="c-machine-introduction_preparation">
                        <img id="top-machine-introduction" class="c-machine-introduction_preparation-icon"
                             :src="iconUrl" alt="筐体イメージ" data-jest="preparation-icon"
                             @load="isLoadingTopImage = false">
                        <p class="c-machine-introduction_preparation-txt">
                            ただ今準備中です。<br>
                            公開までお待ちください。
                        </p>
                    </div>
                    <!--公開日後-->
                    <div v-else class="c-machine-introduction_published">
                        <machine-top-campaign-banner :time-trip-date="accountStatus.timeTripDate"
                                                     :machine-id="machineId"/>
                        <div id="top" class="c-machine-introduction-top">
                            <div class="visual-main">
                                <img :src="buildUrlImage('top.png')" :alt="machineData.name"
                                     @load="isLoadingTopImage = false">

                                <div v-if="isSearchable" class="btn-shop-list">
                                    <img :src="buildUrlImage('btn_shop.png')"
                                         @click="transitionPage(shopSearchUrl, '遊べるお店はこちら', '_self', 'shop-search')"
                                         alt="遊べるお店はこちら"
                                         class="btn-shop-list-link"
                                         data-jest="btn-shop">
                                </div>
                            </div>

                            <!-- キャンペーン -->
                            <div v-if="this.$slots['content-campaign']" class="content-campaign">
                                <slot name="content-campaign"/>
                            </div>

                            <!-- アンカーリンク -->
                            <div class="list-anchor-link-feature-summary">
                                <div class="list-anchor-link">
                                    <h2 v-if="hasTitleAnchorLink" class="list-anchor-link-title">
                                        <img :src="buildUrlImage('link_title.png')" alt="Contents">
                                    </h2>

                                    <img v-if="hasTopBorderAnchorLink" class="img-line"
                                         :src="buildUrlImage('line_0.png')" alt="区切り線">
                                    <template v-for="(sectionTitle, index) in sectionTitleList">
                                        <template v-if="!hiddenSectionNumberList.includes(index+1)">
                                            <a v-scroll-to="`#contents_${index+1}`"
                                               @click="sendClickAll(`${pageUrl}#contents_${index+1}`, sectionTitle)"
                                               :data-jest="`link_${index+1}`">
                                                <img class="img-link" :src="buildUrlImage(`link_${index+1}.png`)"
                                                     :alt="sectionTitle">
                                            </a>
                                            <img v-if="hasBorderAnchorLink" class="img-line"
                                                 :src="buildUrlImage(`line_${index+1}.png`)" alt="区切り線">
                                        </template>
                                    </template>
                                </div>

                                <!-- 特徴のまとめ -->
                                <div v-if="this.$slots['feature-summary']" class="feature-summary">
                                    <slot name="feature-summary"/>
                                </div>
                            </div>
                        </div>

                        <div class="c-machine-introduction-contents">
                            <!-- contents -->
                            <template v-for="(sectionTitle, index) in sectionTitleList">
                                <div v-if="!hiddenSectionNumberList.includes(index+1)" :id="`contents_${index+1}`"
                                     class="accordion" :data-jest="`contents_${index+1}`">
                                    <h3><img :src="buildUrlImage(`title_${index+1}.png`)" :alt="sectionTitle"></h3>
                                    <div class="accordion-inner" :class="`cont-${index+1}`">
                                        <slot :name="`content-${index+1}`"/>
                                    </div>
                                </div>
                            </template>
                            <!-- −/＋で閉じる/開くができる表示の場合 -->
                            <div v-if="this.$slots['accordion-section']" class="accordion-section">
                                <slot name="accordion-section"/>
                            </div>
                        </div>
                        <!-- MOVIE -->
                        <div v-if="hasMovie" class="c-machine-introduction-movie">
                            <img v-if="hasMovieTitle" class="c-machine-introduction-movie-title"
                                 :src="buildUrlImage('movie_title.png')" :alt="`${machineData.name} SPECIAL MOVIE`">
                            <div v-if="youtubeUrl" class="c-machine-introduction-movie-thumb">
                                <a @click="transitionPage(youtubeUrl, 'SPECIAL MOVIE', '_blank', 'youtube')"
                                   data-jest="movie-link">
                                    <img :src="buildUrlImage('movie_thumbnail.png')" alt="SPECIAL MOVIEサムネイル">
                                </a>
                            </div>
                            <div v-if="machineData.isStudio" class="c-machine-introduction-movie-btn-studio">
                                <a @click="transitionPage(aboutStudioPuriUrl, '証明プリ搭載', '_blank', 'studio')"
                                   data-jest="movie-studio-link">
                                    <img :src="studioBtnSrc" alt="証明プリ搭載">
                                </a>
                            </div>
                        </div>
                        <!--TOPへ戻るボタン-->
                        <btn-go-to-page-top v-if="hasPageTopButton"
                                            :img-src="buildUrlCommonImage('btn_page_top.png')" btn-text="PAGE TOP"/>
                    </div>
                    <machine-appeal-sns/>
                </div>
            </div>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "./BaseLayout.vue";
import MachineAppealSns from "../organisms/MachineAppealSns.vue";
import BtnGoToPageTop from "../molecules/BtnGoToPageTop.vue";
import LoadingHeart from "../atoms/LoadingHeart.vue";
import ErrorNotFoundContent from "../organisms/ErrorNotFoundContent.vue";
import WrapperModalPrivacyPolicyAgreement from "../organisms/WrapperModalPrivacyPolicyAgreement.vue";
import * as urlUtil from "../../util/UrlUtil";
import * as machineListGetJsonAction from "../../model/action/MachineListGetJsonAction.js";
import {getClickAllEvent} from "../../util/Ga4EventUtil.js";
import {mapGetters} from "vuex";
import {headerType} from "../../view-model/enum/HeaderType";
import {footerType} from "../../view-model/enum/FooterType";
import MachineTopCampaignBanner from "../organisms/campaigns/banners/CampaignBannerPresenter.vue";

export default {
    name: "LayoutMachineIntroduction",
    components: {
        WrapperModalPrivacyPolicyAgreement,
        MachineTopCampaignBanner,
        BaseLayout,
        MachineAppealSns,
        BtnGoToPageTop,
        LoadingHeart,
        ErrorNotFoundContent
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            machineData: null,
            pageUrl: `/sp/machine/${this.machineId}`,
            iconUrl: urlUtil.imageUrlUtil.machineThumbUrl(this.machineId),
            studioBtnSrc: urlUtil.imageUrlUtil.machineIntroductionCommonImageUrl('btn_studio.png'),
            aboutStudioPuriUrl: '/web/machine/1001', // 証明プリ説明ページ
            isLoadingData: true,
            isLoadingTopImage: true,
            isErrorNotFound: false,
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 筐体ID
         */
        machineId: {
            type: Number,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
        /**
         * アンカーリンクにタイトルをつけるか
         */
        hasTitleAnchorLink: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * アンカーリンクの上にボーダー画像をつけるか
         */
        hasTopBorderAnchorLink: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * セクションタイトルのList
         */
        sectionTitleList: {
            type: Array,
            required: true
        },
        /**
         * 非表示にするセクション番号のList
         * sectionTitleListの並び順に1始まりで数えた番号を指定する
         * 例) [1, 5] を渡すと1番目と5番目のセクション(アンカーリンク・コンテンツ)を表示しない
         * 非表示にしても残りのセクションの番号は繰り上がらないため、画像名やアンカーリンクのIDは変わらない
         */
        hiddenSectionNumberList: {
            type: Array,
            required: false,
            default: () => []
        },
        /**
         * 紹介ムービーのYouTubeのURL
         */
        youtubeUrl: {
            type: String,
            required: false,
            default: ''
        },
        /**
         * アンカーリンクに別でボーダー画像をつけるか
         */
        hasBorderAnchorLink: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * イントロダクションムービーにタイトル画像をつけるか
         */
        hasMovieTitle: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * ムービーの領域を表示させるか
         */
        hasMovie: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * TOPへ戻るボタンを表示させるか
         */
        hasPageTopButton: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: ['puri-list', 'shop-search', 'youtube', 'studio'],
    computed: {
        ...mapGetters('AccountStoreV2', [
            'accountStatus'
        ]),
        /**
         * 紹介ページ公開中かどうか
         */
        isPagePublished() {
            if (this.accountStatus && this.machineData) {
                return this.accountStatus.timeTripDate.isAfterTime(this.machineData.pictlinkLaunchAt)
            } else {
                return false;
            }
        },
        /**
         * 「遊べるお店はこちら」ページのURL
         */
        shopSearchUrl() {
            return urlUtil.servletUrlUtil.shopSearchUrl(this.machineData.name)
        },
    },
    mounted() {
        this.getDataMachine()
    },
    methods: {
        /**
         * 筐体IDをもとに筐体情報を取得する
         */
        getDataMachine() {
            this.isLoadingData = true
            machineListGetJsonAction.getMachineData(this.machineId)
                .then(data => {
                    this.machineData = data[0]
                    this.isErrorNotFound = false
                    this.isLoadingData = false
                }).catch((err) => {
                this.machineData = null
                this.isErrorNotFound = true
                this.isLoadingData = false
            })
        },
        /**
         * GA4にclick allイベントを送信する
         * @param {string} url elementUrl
         * @param {string} text elementText
         */
        sendClickAll(url, text) {
            getClickAllEvent(url, text)
        },
        /**
         * GA4イベントを送信してから指定したページに遷移させる
         * @param {string} url elementUrl
         * @param {string} elementText elementText
         * @param {string} transitionTarget 別窓指定
         * @param {string} buttonKind ボタン種別
         */
        transitionPage(url, elementText, transitionTarget, buttonKind) {
            this.emit(buttonKind)
            this.sendClickAll(url, elementText)
            window.open(url, transitionTarget)
        },
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildUrlImage(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * 共通画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildUrlCommonImage(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionCommonImageUrl(imgName)
        },
        /**
         * 親コンポーネントでページ個別ログなどを送りたい場合のためのemit
         */
        emit(buttonKind) {
            this.$emit(buttonKind);
        }
    }
}
</script>

<style scoped lang="scss">

.c-machine-introduction {
    &_published {
        text-align: center;
    }

    &_preparation {
        text-align: center;
        margin: 10px 0;

        &-icon {
            width: 30%;
            padding: 10px 0;
        }

        &-txt {
            font-weight: bold;
            line-height: 1.3;
            padding-bottom: 20px;
        }
    }

    &-top {
        text-align: center;
        position: relative;
    }
}

</style>
